import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { captureReactQueryError } from './utils/captureReactQueryError';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      captureReactQueryError(error, { kind: 'query', query });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _ctx, mutation) => {
      captureReactQueryError(error, { kind: 'mutation', mutation });
    },
  }),
});
